export const CONTACT_EMAIL = 'servicedesk@ivdnt.org';

export const PROJECT_DISPLAY_NAME = process.env.VUE_APP_PROJECT_DISPLAY_NAME as string;

const BACKEND_URL = '/solr-api';

export const SEARCH_URL = `${BACKEND_URL}/search`;
export const DOCS_URL = `${BACKEND_URL}/docs`;
export const SUGGEST_URL = `${BACKEND_URL}/suggest`;
